module.exports = __webpack_public_path__ + "static/bug-light-83ca337bf498b0839857991670ba82d0.jpg";